const THERMOMIXER_MODELS = new Set<string>(['ThermoMixer C', 'ThermoMixer F1.5']);

/**
 * Check if a device is a Thermomixer (ThermoMixer C / ThermoMixer F1.5)
 */
export function isThermomixer(device?: { model?: string } | null): boolean {
  return !!device?.model && THERMOMIXER_MODELS.has(device.model);
}

/** Telemetry IDs to hide from history charts for Thermomixer devices */
export const THERMOMIXER_HIDDEN_CHART_PARAMS = new Set(['timer']);
